//======================================================
import Vue from 'vue';
import numeral from 'numeral';
Vue.use(numeral);
//======================================================
export const registerGlobalFilters = function () {
    Vue.filter("formatNumber", function (value) {
        return numeral(value).format("0,0"); 
    });

    Vue.filter('fileSize', function (size) {
        const scale = 1024;
        const orders = ["اکسابایت", "پنتابایت", "ترابایت", "گیگابایت", "مگابایت", "کیلوبایت", "بایت"];
        let max = Math.pow(scale, orders.length - 1);

        for (let i = 0; i < orders.length; i++) {
            const order = orders[i];
            if (size > max) {
                return `${(size / max).toFixed(2)} ${order}`;
            }

            max /= scale;
        }

        return "0 Bytes";
    });
}
//======================================================

